import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';
import { space } from 'styled-system';
import { applyVariations, borders, getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const TextArea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "TextArea",
  componentId: "sc-1qq7bjn-0"
})(["appearance:none;display:block;width:100%;font-family:inherit;font-size:", "px;color:inherit;background-color:transparent;border-radius:", ";border-width:1px;border-style:solid;padding-top:14px;padding-bottom:14px;padding-left:12px;padding-right:12px;margin:0;::placeholder{color:", ";}::-ms-clear{display:none;}", " ", " ", ";"], themeGet('fontSizes.1'), themeGet('borderRadii.lg'), getPaletteColor('text.light'), applyVariations('TextArea'), borders, space);
TextArea.displayName = 'TextArea';
TextArea.isField = true;